import React from "react";
import CustomTabsGrid from "components/CustomTabs/CustomTabsGrid.js";
import Thongkexedien from "components/Thongke/Xedien/Thongkexedien.js";
export default function Tkxedien() {
  return (
    <div>
      <CustomTabsGrid
        headerColor="primary"
        tabs={[
          {
            tabName: "Tra cứu thí điểm xe điện",
            tabContent: <Thongkexedien />,
          },
        ]}
      />
    </div>
  );
}
